import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { PageHeader, Card, Btn, Input } from "../ui";
import { useAuth } from "../AuthContext";
import { toast } from "sonner";
import {
  ArrowLeft, LayoutDashboard, Clock, Info, GraduationCap, MessageSquare,
  Phone, CheckCircle2, Layers,
} from "lucide-react";

const MODULES = [
  { icon: LayoutDashboard, name: "Dashboard", desc: "Pagina principala, statistici, KPI-uri" },
  { icon: Clock, name: "Pontaj", desc: "Absente, cereri, bonuri masa, zile lucratoare" },
  { icon: Info, name: "Informatii", desc: "Proceduri, informatii utile, news" },
  { icon: GraduationCap, name: "Antrenament", desc: "Testare, materiale, evaluari, statistici" },
  { icon: MessageSquare, name: "Mesaje", desc: "Comunicare interna, notificari" },
];

export default function ComplexApp() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [phone, setPhone] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (phone.trim().length < 4) {
      toast.error("Introdu un numar de telefon valid");
      return;
    }
    setSending(true);
    try {
      await api.post("/complex-app/request-access", { phone: phone.trim() });
      setSent(true);
      toast.success("Solicitarea a fost trimisa");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eroare la trimitere");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="complex-app-page">
      <div className="mb-4">
        <Btn variant="outline" data-testid="back-to-simple-admin-top" onClick={() => nav("/")}>
          <ArrowLeft className="w-4 h-4" /> Revenire la Admin simplificat
        </Btn>
      </div>

      <PageHeader
        title="Aplicatia complexa"
        subtitle="ERP AMEL - platforma completa de management enterprise pentru productie si operatiuni. Aplicatia completa are 36 de module."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {MODULES.map((m) => (
          <Card key={m.name} className="p-5" data-testid={`module-${m.name.toLowerCase()}`}>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg border border-slate-200 flex items-center justify-center shrink-0">
                <m.icon className="w-5 h-5 text-slate-700" />
              </div>
              <div>
                <div className="font-medium text-slate-900">{m.name}</div>
                <div className="text-sm text-slate-500 mt-1">{m.desc}</div>
              </div>
            </div>
          </Card>
        ))}
        <Card className="p-5 flex items-center gap-3" data-testid="module-more">
          <div className="w-10 h-10 rounded-lg border border-slate-200 flex items-center justify-center shrink-0">
            <Layers className="w-5 h-5 text-slate-700" />
          </div>
          <div>
            <div className="font-medium text-slate-900">Si inca 31 de module</div>
            <div className="text-sm text-slate-500 mt-1">Facturare, stocuri, comenzi, CRM, rapoarte si altele</div>
          </div>
        </Card>
      </div>

      <Card className="p-6 max-w-2xl">
        {sent ? (
          <div className="flex items-start gap-3" data-testid="complex-app-request-sent">
            <CheckCircle2 className="w-6 h-6 text-emerald-600 shrink-0" />
            <div>
              <div className="font-medium text-slate-900">Solicitarea a fost trimisa</div>
              <div className="text-sm text-slate-500 mt-1">
                Echipa te va contacta la numarul {phone} pentru a discuta despre activarea aplicatiei complexe.
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Phone className="w-4 h-4 text-slate-400" />
              <h3 className="font-medium text-slate-900">Doresc sa fiu contactat</h3>
            </div>
            <p className="text-sm text-slate-600 mb-4">
              Doresc sa fiu contactat la numarul de telefon de mai jos pentru a discuta despre activarea paginii complexe.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Input
                data-testid="complex-app-phone-input"
                type="tel"
                placeholder="Numarul tau de telefon"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="sm:max-w-xs"
              />
              <Btn data-testid="complex-app-request-button" onClick={submit} disabled={sending}>
                <Phone className="w-4 h-4" /> {sending ? "Se trimite..." : "Trimite solicitarea"}
              </Btn>
            </div>
          </div>
        )}
      </Card>

      <div className="mt-8">
        <Btn variant="outline" data-testid="back-to-simple-admin-bottom" onClick={() => nav("/")}>
          <ArrowLeft className="w-4 h-4" /> Revenire la Admin simplificat
        </Btn>
      </div>
    </div>
  );
}
